import api from "@/config/api";
import useUser from "@/context/user";
import { Organization } from "@/types/org";
import { log } from "@/utils/logger";
import storage from "@/utils/storage";
import { useQuery } from "@tanstack/react-query";

const useQueryOrganization = () => {
    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");
    const enabled = authenticated && !!oid;

    const getOrganization = async () => {
        try {
            const data = await api.get<Organization>(`/organizations/${oid}`);
            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({
        queryKey: ["organization", oid],
        queryFn: getOrganization,
        enabled,
    });
};

export default useQueryOrganization;
